import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../../hooks'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'

import {
  getIsListingRowActive,
  renderCell,
} from './RentalPortalListingsTableRow.utils'

import * as styles from './RentalPortalListingsTableRow.module.css'

function RentalPortalListingsTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  activeItem,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  hideCheckbox,
  index,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  ...restProps
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps })

  const { id } = item

  const qaProps = getTableRowQaProps()

  const className = useTableRowModClassName({
    className: styles.RentalPortalListingsTableRow,
    isActive: getIsListingRowActive({ activeItem, focusedRow, id }),
    isSelected,
  })

  return (
    <div
      {...qaProps}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      key={id}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            t,
            timezone,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item).length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalListingsTableRow
